export default __webpack_public_path__ + "static/media/infoArquivo.f3b4eea0.svg";